import { useState, useEffect } from "react";
import axios from "../customAxios.js";
import { Alert, Grid, Button, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import es from "date-fns/locale/es";
import CustomTableNew from "../components/CustomTableNew.jsx";
import { dateToDatabase } from "../utils/functions";
import LoadingComponent from "../components/LoadingComponent.jsx";
import PickUpModal from "../components/PickUpModal.jsx";

function ClickAndCollect(props) {
  const isPickUp = props.isPickUp;
  const filterObjectName = isPickUp ? "pickUpFilter" : "clickAndCollectFilter";

  const [openModal, setOpenModal] = useState(false);

  //values to control pagination of the component table
  const [page, setPage] = useState(
    localStorage.getItem(filterObjectName)
      ? JSON.parse(localStorage.getItem(filterObjectName)).page
      : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem(filterObjectName)
      ? JSON.parse(localStorage.getItem(filterObjectName)).rowsPerPage
      : 20
  );

  //data that will be set on every page change and filter set
  const [pageData, setPageData] = useState();
  const [loadingPageData, setLoadingPageData] = useState(true);

  // const [loading, setLoading] = useState(false);
  const daysOffset = props.daysOffset;

  const [servicesTypes, setServicesTypes] = useState([]);

  //filter values of the table
  const [startDate, setStartDate] = useState(
    localStorage.getItem(filterObjectName)
      ? new Date(JSON.parse(localStorage.getItem(filterObjectName)).startDate)
      : new Date(new Date().setDate(new Date().getDate() - daysOffset))
  );
  const [endDate, setEndDate] = useState(
    localStorage.getItem(filterObjectName)
      ? new Date(JSON.parse(localStorage.getItem(filterObjectName)).endDate)
      : new Date()
  );
  const [search, setSearch] = useState(
    localStorage.getItem(filterObjectName)
      ? JSON.parse(localStorage.getItem(filterObjectName)).search
      : ""
  );

  //aux values for delay on text search fields
  const [auxSearcher, setAuxSearcher] = useState(
    localStorage.getItem(filterObjectName)
      ? JSON.parse(localStorage.getItem(filterObjectName)).search
      : ""
  );

  const [counters, setCounters] = useState({});
  const [counterLabels, setCounterLabels] = useState();

  const [errorOnRetrieveData, setErrorOnRetrieveData] = useState();
  const [isInitialRender, setIsInitialRender] = useState(true);

  //useState to save user type
  const [userType, setUserType] = useState(props.mode);

  //useState to catch when general data is already fetched
  const [generalParamsFetched, setGeneralParamsFetched] = useState(false);

  //useState to count the number of orders filtered by backend
  const [ordersCount, setOrdersCount] = useState(0);

  const searchParams = () => {
    let params = {
      start_date: dateToDatabase(startDate),
      end_date: dateToDatabase(endDate),
      search: search,
      order_status: isPickUp ? "pick_up_ready" : "pending_assignment",
      order_type: isPickUp ? "pick_up" : "click_collect",
    };
    if (isPickUp) {
      params.delivery_shipping_method = "pick_up_goex";
    }
    return params;
  };

  useEffect(() => {
    //if localStorage filterObjectName does not exist, set page to 0
    if (!localStorage.getItem(filterObjectName)) {
      setPage(0);
    }
    //if is on useEffect not on initial render, set page 0
    if (isInitialRender) {
      setIsInitialRender(false);
    } else {
      setPage(0);
    }
  }, [startDate, endDate, search, rowsPerPage]);

  useEffect(() => {
    if (!loadingPageData) {
      setLoadingPageData(true);
    }
    fetchOrders();
    //save on localStorage the filter and page values of orders
    localStorage.setItem(
      filterObjectName,
      JSON.stringify({ startDate, endDate, search, page, rowsPerPage })
    );
  }, [startDate, endDate, search, rowsPerPage, page]);

  //useEffect to catch auxSearcher changes, and triger a function every 2 seconds that dont change
  useEffect(() => {
    // Delayed search function
    const delayedSearch = (value) => {
      // Your search logic goes here
      setSearch(value);
    };
    if (!loadingPageData) {
      setLoadingPageData(true);
    }
    // Timer variable for setTimeout
    let timer;

    // Set a delay of 2 seconds before executing the search
    const delay = 1500;

    // Clear the previous timer when auxSearcher changes
    clearTimeout(timer);

    // Set a new timer for delayed search
    timer = setTimeout(() => {
      delayedSearch(auxSearcher);
    }, delay);

    // Clean up the timer on component unmount or when auxSearcher changes
    return () => {
      clearTimeout(timer);
    };
  }, [auxSearcher]);

  //function to fetch all general parameters that do not depends on the page and rowsPerPage
  async function fetchGeneralParams() {
    try {
      const {
        data: { status_counters, order_types, status_choices },
      } = await axios.get("general_params/filtered_orders_new/", {
        params: searchParams(),
      });
      setCounters(status_counters);
      setOrdersCount(status_counters.total_orders);
      setServicesTypes(order_types);
      setCounterLabels(status_choices);
      setErrorOnRetrieveData();
      setGeneralParamsFetched(true);
    } catch (error) {
      console.error(
        `Ocurrió un error al obtener los contadores y opciones de filtro: ${error}`
      );
      setErrorOnRetrieveData(
        "Ocurrió un error al obtener los contadores y opciones de filtro"
      );
    }
  }

  //function to fetch the page data depending on filters, and pagination params
  async function fetchOrders() {
    const search_params_fetch_orders = {
      start_date: dateToDatabase(startDate),
      end_date: dateToDatabase(endDate),
      order_status: isPickUp ? "pick_up_ready" : "pending_assignment",
      order_type: isPickUp ? "pick_up" : "click_collect",
      search: search,
      page: page,
      rowsPerPage: rowsPerPage,
    };

    if (isPickUp) {
      search_params_fetch_orders.delivery_shipping_method = "pick_up_goex";
    }

    setLoadingPageData(true);
    try {
      const { data: orders } = await axios.get("filtered_orders_new/", {
        params: search_params_fetch_orders,
      });
      setPageData(orders);
      setErrorOnRetrieveData();
    } catch (error) {
      console.error(`Ocurrió un error al obtener las órdenes: ${error}`);
      setPageData([]);
      setErrorOnRetrieveData("Ocurrió un error al obtener las órdenes");
    } finally {
      setLoadingPageData(false);
    }
  }

  useEffect(() => {
    fetchGeneralParams();
  }, [startDate, endDate, search]);

  const headerTable = [
    { columnName: "Id Referencia", dbName: "id", enabled: true },
    { columnName: "Id Go-ex", dbName: "id_goex", enabled: true },
    {
      columnName: "Seller",
      dbName: "seller_company_social_reason",
      enabled: true,
    },
    { columnName: "Destinatario", dbName: "recipient", enabled: true },
    { columnName: "Fecha de Ingreso", dbName: "creation_date", enabled: true },
    { columnName: "Validación QR", dbName: "QR_string", enabled: true },
    { columnName: "Acciones", dbName: "confirm_delivery", enabled: true },
    { columnName: "Detalles", dbName: "details", enabled: true },
  ];

  if (generalParamsFetched) {
    return (
      <>
        <Grid item xs={12}>
          <h1>Tus órdenes {isPickUp ? "Pick Up" : "Click & Collect"} </h1>
        </Grid>

        <Grid item xs={12} sm className="flex-left filters-container">
          <div className="row-container request-search-container">
            <Grid container>
              <Grid item xs={6} sm="auto" className="input-date-filter">
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={es}
                >
                  <DatePicker
                    label="Fecha de inicio"
                    value={startDate}
                    onChange={(newValue) => {
                      if (endDate < newValue) {
                        let newEndDate = new Date(newValue);
                        newEndDate.setDate(newEndDate.getDate() + daysOffset);
                        setEndDate(newEndDate);
                      }
                      setStartDate(newValue);
                    }}
                    // disabled={ordersFiltered === undefined}
                    className="mg-r-10"
                  />
                </LocalizationProvider>
              </Grid>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
              >
                <DatePicker
                  label="Fecha de fin"
                  value={endDate}
                  onChange={(newValue) => {
                    if (newValue < startDate) {
                      let newStartDate = new Date(newValue);
                      newStartDate.setDate(newStartDate.getDate() - daysOffset);
                      setStartDate(newStartDate);
                    }
                    setEndDate(newValue);
                  }}
                  disabled={startDate === null}
                  className="mg-r-10 mg-l-10"
                />
              </LocalizationProvider>

              <TextField
                variant="outlined"
                label="Buscar"
                name="search"
                value={auxSearcher}
                onChange={(e) => {
                  setAuxSearcher(e.target.value);
                }}
                className="mg-l-10"
                disabled={false}
              />
            </Grid>

            {isPickUp && (
              <Grid item xs={6} sm="auto" className="input-service-filter">
                <Button
                  variant="outlined"
                  component="label"
                  color="secondary"
                  className="mg-l-10"
                  onClick={() => {
                    setOpenModal(true);
                  }}
                >
                  Recibí una orden Pick Up
                </Button>
              </Grid>
            )}
          </div>
        </Grid>

        <PickUpModal open={openModal} closeModal={() => setOpenModal(false)} />

        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <>
              {errorOnRetrieveData ? (
                <Alert severity="error">{errorOnRetrieveData}</Alert>
              ) : (
                <CustomTableNew
                  searchParams={searchParams}
                  search={search}
                  filterByDate={startDate !== null && endDate !== null}
                  headerTable={headerTable}
                  fetchRequests={fetchOrders}
                  selected={"none"}
                  setSelected={"none"}
                  openCollapseButton={true}
                  openCollapseTooltip={"Ver más"}
                  openCollapseIcon={
                    <i className="material-icons-outlined icon-actions-panel-test">
                      add_circle_outline
                    </i>
                  }
                  collapseType={"click-collect-orders"}
                  hasPagination={true}
                  orderTypes={{ click_collect: "Click & Collect" }}
                  editable={true}
                  filterStates={{ startDate, endDate, search }}
                  totalCount={ordersCount}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  pageData={pageData}
                  setPageData={setPageData}
                  loadingPageData={loadingPageData}
                />
              )}
            </>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return <LoadingComponent />;
  }
}

export default ClickAndCollect;
